export function getGroupLabel(dataGroup, {lowerCase = false} = {}) {
  const label = dataGroup ? `${dataGroup.displayName}(s)` : `Users`;
  return lowerCase ? label.toLowerCase() : label;
}
